import React from 'react';
import styled from 'styled-components';
import { Award, Users, Calendar, Heart } from 'lucide-react';

const AboutContainer = styled.section`
  padding: 100px 0;
  background: #fff;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const AboutContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const AboutText = styled.div`
  h2 {
    font-size: 2.5rem;
    font-weight: 300;
    color: #2c2c2c;
    margin-bottom: 30px;
  }

  p {
    font-size: 1.1rem;
    color: #666;
    line-height: 1.8;
    margin-bottom: 20px;
  }

  .highlight {
    color: #333;
    font-weight: 600;
  }
`;

const AboutImage = styled.div`
  height: 500px;
  background: url('https://images.unsplash.com/photo-1519225421980-715cb0215aed?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80') center/cover;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    height: 300px;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
`;

const StatCard = styled.div`
  text-align: center;
  padding: 40px 20px;
  background: #f8f4f0;
  border-radius: 20px;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  .icon {
    width: 60px;
    height: 60px;
    background: white;
    border: 2px solid #333;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    color: #333;
  }

  h3 {
    font-size: 2.5rem;
    font-weight: 700;
    color: #333;
    margin-bottom: 10px;
  }

  p {
    font-size: 1rem;
    color: #666;
    font-weight: 500;
  }
`;

const AboutSection: React.FC = () => {
  return (
    <AboutContainer>
      <Container>
        <AboutContent>
          <AboutText>
            <h2>SARAYLI MODA</h2>
            <p>
              <span className="highlight">2008'den bugüne</span> uzanan zarafetin mirasını taşıyan Saraylı Moda, 
              gelinlik tasarımında kaliteyi, özgünlüğü ve kusursuzluğu bir araya getiriyor.
            </p>
            <p>
              Tüm modellerimiz markanın kendi bünyesinde tasarlanıyor ve dikiliyor; bu sayede her detay, 
              bir Saraylı Gelini'ne yakışır özenle şekilleniyor.
            </p>
            <p>
              Sınırlı sayıda üretilen özel koleksiyonlarımız yalnızca Saraylı Moda showroomlarında 
              ve resmi web sitemizde sunulmaktadır.
            </p>
          </AboutText>

          <AboutImage />
        </AboutContent>

        <StatsGrid>
          <StatCard>
            <div className="icon">
              <Users size={30} />
            </div>
            <h3>500+</h3>
            <p>Mutlu Gelin</p>
          </StatCard>

          <StatCard>
            <div className="icon">
              <Award size={30} />
            </div>
            <h3>15+</h3>
            <p>Yıllık Deneyim</p>
          </StatCard>

          <StatCard>
            <div className="icon">
              <Calendar size={30} />
            </div>
            <h3>1000+</h3>
            <p>Tamamlanan Proje</p>
          </StatCard>

          <StatCard>
            <div className="icon">
              <Heart size={30} />
            </div>
            <h3>%100</h3>
            <p>Müşteri Memnuniyeti</p>
          </StatCard>
        </StatsGrid>
      </Container>
    </AboutContainer>
  );
};

export default AboutSection;
